import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["paragraghHeading", _ctx.heading.heading_margin])
  }, [
    (_ctx.heading.heading_type === 'h2')
      ? (_openBlock(), _createElementBlock("h2", {
          key: 0,
          textContent: _toDisplayString(_ctx.heading.heading_text)
        }, null, 8, _hoisted_1))
      : (_ctx.heading.heading_type === 'h3')
        ? (_openBlock(), _createElementBlock("h3", {
            key: 1,
            textContent: _toDisplayString(_ctx.heading.heading_text)
          }, null, 8, _hoisted_2))
        : (_ctx.heading.heading_type === 'h4')
          ? (_openBlock(), _createElementBlock("h4", {
              key: 2,
              textContent: _toDisplayString(_ctx.heading.heading_text)
            }, null, 8, _hoisted_3))
          : (_ctx.heading.heading_type === 'h5')
            ? (_openBlock(), _createElementBlock("h5", {
                key: 3,
                textContent: _toDisplayString(_ctx.heading.heading_text)
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
  ], 2))
}